import { Country } from '../country.model';
import { CountriesActions, CountriesActionTypes } from './country.actions';

export interface CountriesState {
    countryList: Country[];
    loaded: boolean;
}

export const initialState: CountriesState = {
    countryList: [],
    loaded: false,
};

export function countriesReducer(state = initialState, action: CountriesActions): CountriesState {

    switch (action.type) {
        case CountriesActionTypes.LoadCountriesSuccess:
            return {
                ...state,
                countryList: action.payload,
                loaded: true
            };
        default:
            return state;
    }
}
